module.exports = __webpack_public_path__ + "img/start_show.1a27d325.png";